import { useMemo } from 'react';

import { useIsQuestionsOnlyMode } from '../../featureChecks';
import type { UseMainUIFeatureSettings } from '../../types';
import { uiFeatureAccessSymbol } from '../../types';

export const useInboxPageSettings: UseMainUIFeatureSettings<'inboxPage'> = (options) => {
  const inboxPageOverrides = options?.overrides?.inboxPage;

  const isQuestionsOnlyMode = useIsQuestionsOnlyMode();

  return useMemo(() => {
    if (isQuestionsOnlyMode) {
      return {
        [uiFeatureAccessSymbol]: false,
        ...inboxPageOverrides,
      };
    }

    return {
      [uiFeatureAccessSymbol]: true,
      ...inboxPageOverrides,
    };
  }, [inboxPageOverrides, isQuestionsOnlyMode]);
};
